import React, { FC } from 'react';
import { Radio as MuiRadio, RadioProps } from '@mui/material';
import styled from 'styled-components';

const StyledRadio = styled(MuiRadio)`
  color: var(--primary-color);
  &.Mui-checked {
    color: var(--primary-color);
  }
  &.MuiRadio-colorPrimary {
    color: var(--primary-color);
  }
`;

export const Radio: FC<RadioProps> = ({ ...rest }) => <StyledRadio {...rest} />;
